import importer from 'common/importer'
const Config = importer('Config')
/* NAVIGATOR */
const { genAuthUrl } = importer('NavigationService', null)
/*  */
const { oktaOauthReq: req, oktaOauthUrl: url } = importer('APIs', null)
/**
 * Login Callout 2 Oauth with Okta using that Session Token
 *
 * @param {Object} param0
 * @param {String} param0.client_id default: 0oasfurmtqEoa1WaR0h7
 * @param {String} param0.response_type default: code
 * @param {String} param0.scope default: openid
 * @param {String} param0.sessionToken REQUIRED
 * @param {String} param0.state default: state-296bc9a0-a2a2-4a57-be1a-d0e2fd9bb00601
 * @param {String} param0.nonce default: nonce-285shskiooo989
 * @param {String} param0.code_challenge_method default: S256
 * @param {String} param0.code_challenge default: qjrzSW9gMiUgpUvqgEPE4_-8swvyCtfOVvg55o5S_es
 */
const main = ({
  client_id = Config.OKTA_CLIENT_ID || WEB_OKTA_CLIENT_ID,
  response_type = 'code',
  scope = Config.OKTA_SCOPE,
  sessionToken,
  state = Config.OKTA_STATE,
  nonce = Config.OKTA_NONCE,
  code_challenge_method = Config.OKTA_CODE_CHALLENGE_METHOD,
  code_challenge = Config.OKTA_CODE_CHALLENGE
}) => {
  return req.get('/authorize', {
    params: {
      redirect_uri: genAuthUrl('/authorize'),
      client_id,
      response_type,
      scope,
      sessionToken,
      state,
      code_challenge_method,
      code_challenge
    }
  })
}
/**
 * Login Callout 2 Oauth with Okta using that Session Token
 *
 * @param {Object} param0
 * @param {String} param0.client_id default: 0oasfurmtqEoa1WaR0h7
 * @param {String} param0.response_type default: code
 * @param {String} param0.scope default: openid
 * @param {String} param0.sessionToken REQUIRED
 * @param {String} param0.state default: state-296bc9a0-a2a2-4a57-be1a-d0e2fd9bb00601
 * @param {String} param0.nonce default: nonce-285shskiooo989
 * @param {String} param0.code_challenge_method default: S256
 * @param {String} param0.code_challenge default: qjrzSW9gMiUgpUvqgEPE4_-8swvyCtfOVvg55o5S_es
 */
export const getCallout2Url = ({
  client_id = Config.OKTA_CLIENT_ID || WEB_OKTA_CLIENT_ID,
  response_type = 'code',
  scope = Config.OKTA_SCOPE,
  sessionToken,
  state = Config.OKTA_STATE,
  nonce = Config.OKTA_NONCE,
  code_challenge_method = Config.OKTA_CODE_CHALLENGE_METHOD,
  code_challenge = Config.OKTA_CODE_CHALLENGE
}) => {
  return url + '/authorize?' +
    'redirect_uri=' + genAuthUrl('/authorize') + '&' +
    'client_id=' + client_id + '&' +
    'scope=' + scope + '&' +
    'response_type=' + response_type + '&' +
    'sessionToken=' + sessionToken + '&' +
    'state=' + state + '&' +
    'code_challenge_method=' + code_challenge_method + '&' +
    'code_challenge=' + code_challenge
}
/**
 * Login Callout 3 Exchange Code for Tokens
 *
 * @param {Object} param0
 * @param {String} param0.code_verifier OPTIONAL
 * @param {String} param0.grant_type OPTIONAL
 * @param {String} param0.code REQUIRED
 */
export const exchangeTokens = ({
  code_verifier = Config.OKTA_CODE_VERIFIER || WEB_OKTA_CODE_VERIFIER,
  grant_type = 'authorization_code',
  code,
  client_id = Config.OKTA_CLIENT_ID || WEB_OKTA_CLIENT_ID,
  scope = Config.OKTA_SCOPE,
  headers = {
    'content-type': 'application/x-www-form-urlencoded',
    accept: 'application/json'
  }
}) => {
  const data = `grant_type=${grant_type}&client_id=${client_id}&redirect_uri=${genAuthUrl('/authorize')}&code=${code}&code_verifier=${code_verifier}&scope=${scope}`
  const config = {
    // withCredentials: true,
    headers: {
      ...headers
    }
  }
  return req.post('/token', data, config)
}

export default main
